import React from 'react';
import { Helmet } from 'react-helmet';
import { useConfig } from '../context/ConfigContext';

// This component can be placed in your main component
const ProductHeader = ({ selectedProduct }) => {
  const { config } = useConfig();

  // Use brand colors from config, with fallbacks
  const primaryColor = config?.colors?.primary || '#1e3c72';
  const secondaryColor = config?.colors?.secondary || '#2a5298';

  // Create gradient using brand colors
  const gradientStyle = {
    background: `linear-gradient(135deg, ${primaryColor} 0%, ${secondaryColor} 100%)`,
    opacity: 0.95
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>{selectedProduct?.name ? `${selectedProduct.name} ` : 'Product '}</title>
        <meta name="description" content={selectedProduct?.description || 'Product description'} />
        <meta property="og:title" content={selectedProduct?.name || 'Product'} />
        <meta property="og:description" content={selectedProduct?.description || 'Product description'} />
        <meta property="og:type" content="product" />
        <meta property="og:url" content={`/products/${selectedProduct?.id}`} />
        <meta property="og:image" content={selectedProduct?.image || '/default-product.jpg'} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={selectedProduct?.name || 'Product'} />
        <meta name="twitter:description" content={selectedProduct?.description || 'Product description'} />
        <link rel="canonical" href={`/products/${selectedProduct?.id}`} />
        <meta name="keywords" content={`${selectedProduct?.name}, ${selectedProduct?.category}, your brand keywords`} />
        <meta name="robots" content="index, follow" />
      </Helmet>

      {/* Enhanced Product Header with Brand Color Gradient Background */}
      <div className="w-full my-8 p-8 text-center relative overflow-hidden shadow-lg rounded-lg">
        {/* Brand color gradient background */}
        <div
          className="absolute inset-0"
          style={gradientStyle}
        />

        {/* SEO-friendly content with enhanced typography */}
        <div className="relative z-10">
          <h1 className="text-2xl sm:text-2xl md:text-4xl font-bold text-white leading-tight mb-3 tracking-tight">
            {selectedProduct?.name || 'Product Name'}
          </h1>
          <div className="w-16 h-1 bg-white bg-opacity-30 mx-auto my-4"></div>
          <h2 className="mx-auto text-sm text-justify text-center sm:text-base text-white text-opacity-90  leading-relaxed px-8 ">
            {selectedProduct?.description || ' '}
          </h2>
        </div>
      </div>
    </>
  );
};

export default ProductHeader;